export default "__VITE_ASSET__CV6iI2Lx__"